import { FC, PropsWithChildren } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import NotFoundPage from "@/layouts/not-found"

// Route Modules
import { PublicRoutes } from "./routes/public"
import { AdminRoutes } from "./routes/admin"
import { BusinessRoutes } from "./routes/business"

const RoutesProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Public Marketing & Auth Routes */}
        {PublicRoutes()}

        {/* Business Dashboard Routes */}
        {BusinessRoutes()}

        {/* Admin Dashboard Routes */}
        {AdminRoutes()}

        {/* 404 fallback */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {children}
    </BrowserRouter>
  )
}

export default RoutesProvider
